import { useLayoutEffect, type DependencyList } from 'react';

const APP_PAGE_SELECTOR = '.soundpill-app-shell__page';

/** AppRoute 메인 스크롤 컨테이너 상단으로 */
export function scrollAppShellPageToTop() {
  const scrollEl = document.querySelector<HTMLElement>(APP_PAGE_SELECTOR);
  if (!scrollEl) return;
  scrollEl.scrollTo({ top: 0, left: 0 });
  scrollEl.scrollTop = 0;
}

/** AppRoute 스크롤 컨테이너를 상단으로 — 페이지 진입 시 사용 */
export function useAppPageScrollToTop(deps: DependencyList) {
  useLayoutEffect(() => {
    scrollAppShellPageToTop();
  }, deps);
}
